import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RcState } from './types';

export const initialState: RcState = {
  step: 1,
  lastVerifiedStep: 0,
  startDate: null,
  endDate: null,
  price: null,
  contractReference: null,
  stripeConfigType: null,
  subscriptionId: null,
  schoolName: null,
};

const rcSlice = createSlice({
  name: 'rc',
  initialState,
  reducers: {
    setStartDate(state, action: PayloadAction<string | null>) {
      state.startDate = action.payload;
    },
    setEndDate(state, action: PayloadAction<string | null>) {
      state.endDate = action.payload;
    },
    setPrice(state, action: PayloadAction<number | null>) {
      state.price = action.payload;
    },
    setContractReference(state, action: PayloadAction<string | null>) {
      state.contractReference = action.payload;
    },
    setStripeConfigType(state, action: PayloadAction<'payment_intent' | null>) {
      state.stripeConfigType = action.payload;
    },
    setSubscriptionId(state, action: PayloadAction<string | null>) {
      state.subscriptionId = action.payload;
    },
    setSchoolName(state, action: PayloadAction<string | null>) {
      state.schoolName = action.payload;
    },
    nextStep(state) {
      state.step += 1;
    },
    prevStep(state) {
      state.step = Math.max(state.step - 1, 1);
    },
    setStepVerified(state, action: PayloadAction<number>) {
      state.lastVerifiedStep = Math.max(state.lastVerifiedStep, action.payload);
    },
    setStep(state, action: PayloadAction<number>) {
      state.step = action.payload;
    },
    reset(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setStartDate,
  setEndDate,
  setPrice,
  setContractReference,
  setStripeConfigType,
  setSubscriptionId,
  setSchoolName,
  nextStep,
  prevStep,
  setStepVerified,
  setStep,
  reset,
} = rcSlice.actions;

export const rcReducer = rcSlice.reducer;
